import React from "react";
import { cn } from "../../helpers/utils/css-utils";

const SectionHeading = ({ title = "", subtitle, icon: Icon, className, children }) => (
  <div className={cn(
    "flex h-16 shrink-0 items-center justify-between gap-3 border-b border-gray-200 bg-white px-4",
    className
  )}>
    <div className="flex min-w-0 items-center gap-3">
      {Icon && <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-600"><Icon size={17} aria-hidden="true" /></span>}
      <div className="min-w-0">
        <h4 title={title} className="truncate text-sm font-semibold text-gray-900">{title}</h4>
        {subtitle && <p title={subtitle} className="mt-0.5 truncate text-xs text-gray-500">{subtitle}</p>}
      </div>
    </div>
    {children}
  </div>
);

export default SectionHeading;
